import { useState, useEffect } from "react";
import BottomNav from "../components/BottomNav";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { objectsApi } from "../services/api";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

const STATUS_COLOR = {
  EN_RECHERCHE:"#1CBCD3", MATCHING_EN_COURS:"#C9922A", PREUVES_EN_COURS:"#C9922A",
  RESTITUTION_ACTIVE:"#1263B0", REMIS:"#16A34A", CLOTURE:"#64748B" };

export default function DossierDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  const nav = useNavigate();
  const [dossier, setDossier] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    objectsApi.getLostById(id)
      .then(r => setDossier(r.data?.data))
      .catch(() => nav("/dashboard"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center",
      justifyContent:"center", background:T.bg }}>
      <div style={{ color:"#64748B" }}>{t("common.loading")}</div>
    </div>
  );

  if (!dossier) return null;

  const statusColor = STATUS_COLOR[dossier.status] || "#94A3B8";

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.night},${T.royal})`,
        padding:"20px 24px", display:"flex", alignItems:"center", gap:"16px" }}>
        <button onClick={()=>nav("/dashboard")}
          style={{ background:"transparent", border:"none", color:T.white, fontSize:"20px", cursor:"pointer" }}>←</button>
        <h1 style={{ color:T.white, fontSize:"17px", fontWeight:700, margin:0 }}>{t("dossier.title")}</h1>
      </div>

      <div style={{ maxWidth:"600px", margin:"0 auto", padding:"24px 24px 80px" }}>
        <div style={{ background:T.white, borderRadius:"16px", padding:"24px 24px 80px",
          border:"1px solid #E2E8F0", marginBottom:"16px" }}>
          <div style={{ display:"flex", justifyContent:"space-between",
            alignItems:"flex-start", marginBottom:"20px" }}>
            <div>
              <h2 style={{ fontSize:"18px", fontWeight:700, color:T.night, margin:0 }}>
                {dossier.objectName || dossier.object_name}
              </h2>
              <p style={{ color:"#64748B", fontSize:"13px", margin:"4px 0 0" }}>{dossier.reference}</p>
            </div>
            <span style={{ fontSize:"11px", fontWeight:700, padding:"4px 12px",
              borderRadius:"20px", background:`${statusColor}20`, color:statusColor }}>
              {dossier.status}
            </span>
          </div>

          {[["dossier.category", dossier.category],
            ["dossier.description", dossier.description],
            ["dossier.location", dossier.lostLocation || dossier.lost_location],
            ["dossier.date", dossier.lostDate || dossier.lost_date]
          ].map(([k,v]) => v && (
            <div key={k} style={{ marginBottom:"16px",
              paddingBottom:"16px", borderBottom:"1px solid #F1F5F9" }}>
              <div style={{ fontSize:"11px", color:"#94A3B8",
                textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"4px" }}>
                {t(k)}
              </div>
              <div style={{ fontSize:"14px", color:T.night }}>{v}</div>
            </div>
          ))}
        </div>

        {dossier.status === "MATCHING_EN_COURS" && (
          <div style={{ background:"#FBF4E8", borderRadius:"16px", padding:"20px",
            border:"2px solid #C9922A", marginBottom:"16px", textAlign:"center" }}>
            <div style={{ fontSize:"32px", marginBottom:"8px" }}>🎯</div>
            <p style={{ color:"#A67820", fontWeight:700, fontSize:"15px", marginBottom:"16px" }}>
              {t("dossier.matching_found")}
            </p>
            <Link to={`/matching/${dossier.matchingId || dossier.matching_id}`}
              style={{ background:"#C9922A", color:T.white, padding:"12px 24px",
                borderRadius:"12px", textDecoration:"none", fontWeight:700, fontSize:"14px" }}>
              {t("dossier.view_matching")}
            </Link>
          </div>
        )}

        <Link to="/dashboard"
          style={{ display:"block", textAlign:"center", color:"#64748B",
            fontSize:"14px", textDecoration:"none", padding:"12px" }}>
          {t("dossier.back")}
        </Link>
      </div>
      <BottomNav />
    </div>
  );
}
